import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'

class ConnectMsgSuggestions extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      tab: 0,
    }
    this.renderText = this.renderText.bind(this)
    this.renderNavCircle = this.renderNavCircle.bind(this)
    this.prevTab = this.prevTab.bind(this)
    this.nextTab = this.nextTab.bind(this)
  }



  renderText() {
    switch (this.state.tab) {
      case 0:
        return `Hey ${this.props.requestee_name}! Want to connect and schedule a Lex soon?`
      case 1:
        return `Hi ${this.props.requestee_name} - want to connect? Looking for a new Lex partner.`
      case 2:
        return `Hi ${this.props.requestee_name}! Let's connect so we can chat and schedule a Lex. Are you free Tuesday?`
      case 3:
        return `Hi ${this.props.requestee_name}! I'm a serious language learner, looking for more connects. Hope to hear from you!`
      case 4:
        return `Hi ${this.props.requestee_name}! I'm new to Lexody, looking for more connects. What day/time would you be available to Lex next week?`
      default:
        return `Hey! I'm new to Lexody. Want to connect?`
    }
    return
  }

  prevTab() {

    if(this.state.tab != 0) {
      this.setState({
        tab: this.state.tab-1,
      })
    }
  }

  nextTab() {
    if(this.state.tab != 5) {
      this.setState({
        tab: this.state.tab+1,
      })
    }
  }

  renderNavCircle(i) {
    if(i === this.state.tab) {
      return (<div style={{height: 5, width: 5, borderRadius: 5, backgroundColor: '#01579b'}}></div>)
    } else {
      return (<div style={{height: 5, width: 5, borderRadius: 5, backgroundColor: '#FFF'}}></div>)
    }
  }

  render() {
    return(
      <div className="backgroundGradient" style={{borderRadius: 5, padding: 5, margin: 'auto', width: 300, marginBottom: 10}}>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 5, marginBottom: 10, alignItems: 'center'}}>
          <FontAwesomeIcon
            onClick={this.prevTab}
            icon={faArrowLeft}
            style={{
              fontSize: 12,
              cursor: 'pointer',
              color: this.state.tab != 0 ? '#fff' : 'rgba(255,255,255,.3)'}}
          />
          <h5 style={{color: '#FFF', fontWeight: '500', textAlign: 'center'}}>Click suggestion to replace text</h5>
          <FontAwesomeIcon
            onClick={this.nextTab}
            icon={faArrowRight}
            style={{
              fontSize: 12,
              cursor: 'pointer',  
              color: this.state.tab != 5 ? '#fff' : 'rgba(255,255,255,.3)'}}
          />
        </div>
        <button
          onClick={() => this.props.selectPrompt(this.renderText())}
          style={{
            backgroundColor: 'rgba(255,255,255,.2)',
            borderRadius: 5,
            padding: 7,
            margin: 3,
            width: '98%',
            textAlign: 'left',
            minHeight: 50,
            display: 'flex'
          }}>
            <h5 className="sectionText" style={{color: 'white'}}>{this.renderText()}</h5>
        </button>
        <div style={{display: 'flex', flexDirection: 'row', margin: 'auto', width: 75, justifyContent: 'space-between'}}>
          {this.renderNavCircle(0)}
          {this.renderNavCircle(1)}
          {this.renderNavCircle(2)}
          {this.renderNavCircle(3)}
          {this.renderNavCircle(4)}
          {this.renderNavCircle(5)}
        </div>
      </div>
    )
  }
}

export default ConnectMsgSuggestions;
